module.exports = "\n\t<div class=\"c-loading-dots\">\n\t\t<div class=\"c-loading-dots__dot\"></div>\n\t\t<div class=\"c-loading-dots__dot\"></div>\n\t\t<div class=\"c-loading-dots__dot\"></div>\n\t</div>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/scripts/components/loading-dots.vue
// module id = 89
// module chunks = 1 2 3 7 8 9 10 22